import type { MutationTree } from 'vuex';
import type { ITwilioState } from '@signing-page/integrations/twilio/store/twilio.types';
import { ETwilioMutation } from '@signing-page/integrations/twilio/store/twilio.constants';

export const mutations: MutationTree<ITwilioState> = {
  [ETwilioMutation.SetError](state: ITwilioState, error: string) {
    state.error = error;
  },
  [ETwilioMutation.SetLoading](state: ITwilioState, loading: boolean) {
    state.loading = loading;
  },
  [ETwilioMutation.SetCallSid](state: ITwilioState, callSid: string) {
    state.callSid = callSid;
  },
};
